<template>
  <div v-if="showBanner" class="relative bg-orange-400">
    <div class="flex p-4 mx-auto max-w-7xl sm:justify-center sm:px-6 lg:px-8">
      <div class="pr-16 sm:px-16 sm:text-center">
        <div class="block font-medium text-white sm:item-center sm:flex sm:space-x-2">
          <div>
            You have <b>{{ trialDaysRemaining }}</b> days left on your free trial.
          </div>
          <div>
            <router-link
              to="/subscription"
              class="relative inline-flex items-center justify-center w-full px-4 py-2 mt-2 text-sm font-medium text-center text-gray-800 rounded-md shadow-sm bg-slate-100 hover:bg-slate-200 focus:outline-none focus:ring-2 focus:ring-gray-300 focus:ring-offset-2 sm:mt-0 md:w-auto"
            >
              <span>Upgrade now</span>
            </router-link>
          </div>
        </div>
      </div>

      <div class="absolute inset-y-0 right-0 items-start hidden pt-1 pr-1 sm:flex sm:items-start sm:p-3">
        <button @click="showBanner = false" type="button" class="flex p-2 rounded-md hover:bg-orange-500 focus:outline-none focus:ring-2 focus:ring-white">
          <span class="sr-only">Dismiss</span>
          <XIcon class="w-6 h-6 text-white" aria-hidden="true" />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { XIcon } from "@heroicons/vue/outline";
import { ref } from "vue";
export default {
  components: {
    XIcon,
  },
  props: ["trialDaysLeft"],
  setup(props) {
    const trialDaysRemaining = ref(props.trialDaysLeft);
    const showBanner = ref(true);
    return {
      trialDaysRemaining,
      showBanner,
    };
  },
};
</script>
